import { jsx as _jsx } from "react/jsx-runtime";
// 1. Ant Design
import { Button, Result } from "antd";
// 2. External libraries
import React from "react";
// 5. Types, utils, styles
import styles from "@/styles/LazyChunkBoundary.module.less";
/**
 * Перехватывает ошибку загрузки ленивого чанка (например, ChunkLoadError после деплоя
 * с rsync --delete, когда вкладка открыта со старым index.html) и предлагает обновить
 * страницу вместо белого экрана. Классовый компонент — у React нет функционального
 * аналога error boundary.
 */
class LazyChunkBoundary extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { hasError: false };
        this.handleReload = () => {
            window.location.reload();
        };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error) {
        console.error("Error loading lazy chunk:", error);
    }
    render() {
        return this.state.hasError ? (_jsx("div", { className: styles.container, children: _jsx(Result, { status: "warning", title: "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0430\u0437\u0434\u0435\u043B", subTitle: "\u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043E\u0431\u043D\u043E\u0432\u0438\u043B\u043E\u0441\u044C. \u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443.", extra: _jsx(Button, { type: "primary", onClick: this.handleReload, children: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443" }) }) })) : (this.props.children);
    }
}
LazyChunkBoundary.displayName = "LazyChunkBoundary";
export default LazyChunkBoundary;
